<div class="action-menu-modal" *ngIf="isMenuVisible" #actionMenuModal>
    <div *ngFor=" let menuItem of menuItems"  [ngClass]="{'disabled':isActionMenuItemDisabled(menuItem.actionId)}"
         (click)="menuRowClicked(menuItem.actionId)">
        <bd-fa [name]="menuItem.faName"></bd-fa>
        <span>{{menuItem.label}}

            {{isTCODraft && menuItem.actionId ===  actionEnum.TCO_CALCULATION ? ' (Entwurf)': ''}}</span>
    </div>
</div>


